import { router } from "expo-router";
import React from "react";
import { Pressable, Text, View } from "react-native";

export default function StepHeader({
  title,
  subtitle,
  showBack = true,
  onBack,
}: {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  onBack?: () => void;
}) {
  return (
    <View style={{ padding: 16, paddingBottom: 8, gap: 6 }}>
      {showBack ? (
        <Pressable
          onPress={onBack ?? (() => router.back())}
          style={{
            alignSelf: "flex-start",
            paddingHorizontal: 10,
            height: 32,
            borderRadius: 10,
            borderWidth: 1,
            borderColor: "#e5e7eb",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
          }}
        >
          <Text style={{ fontWeight: "900" }}>← Back</Text>
        </Pressable>
      ) : null}

      <Text style={{ fontSize: 20, fontWeight: "900" }}>{title}</Text>

      {subtitle ? (
        <Text style={{ fontWeight: "700", color: "rgba(0,0,0,0.6)" }}>
          {subtitle}
        </Text>
      ) : null}
    </View>
  );
}
